export const redirectObfuscateLink = () => {
    document.addEventListener('click', e => {
        if (e.target.hasAttribute('data-obfuscate')) {
            const base64Url = e.target.getAttribute('data-obfuscate');
            let decodedUrl = atob(base64Url);
            if (e.target.hasAttribute('data-medium')) {
                decodedUrl = decodedUrl.concat(`?m=${e.target.getAttribute('data-medium')} `);
            }
            window.open(decodedUrl, '_blank');
        }
    });
};
